<template>
    <v-dialog persistent v-model="dialog" width="30%">
        <v-card fluid>
            <v-card-title>
                Disconnect {{ data.acco }} from {{ data.park }}
            </v-card-title>
            <v-divider class="ml-2 mr-2 mb-2"></v-divider>
            <v-card-text>
                <p>You are abount to disconnect {{ data.acco }} from park {{ data.park }}. This means that this will apply:</p>
                <ul>
                    <li>TO codes and names will be removed for all plannings</li>
                    <li>The housing group code (or parkcode) will be removed from {{ data.acco }}</li>
                    <li>The pricing system will remain <b>LOS</b></li>
                    <li>Publication on partners sites will <b>NOT</b> change</li>
                    <li>Accommodation status will also <b>NOT</b> change (live remains live)</li>
                    <li>Accommodation <b>can still be booked</b> but the park will not be notified unless there is an <b>iCal url</b> for the plannings</li>
                    <li>All <b>cost mapping information</b> configured with this unit will be deleted</li>
                </ul>
            </v-card-text>
            <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>              
                <v-btn small @click="closeDialog" color="primary">
                    cancel
                </v-btn>                  
                <v-btn small @click="disconnectAcco" color="warning">
                    disconnect
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    
    export default {
        components: {
        },        
        data() {
            return {
                dialog: false,
                data:{}
            }
        },    
        methods: {
            open(param) {
                this.data = param
                this.dialog = true
            },                    
            closeDialog() {
                this.dialog = false;
            },        
            disconnectAcco(){
                this.$emit('disconnect', this.data);
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>
.flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.text-color{
    color: black !important;
}

</style>